import { AILoader } from './AILoader';
import LoadingMessages from './internal/LoadingMessages';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AIFullPageLoader = ({
  messages,
  isFinished = false,
  onAnimationEnd,
  size = 'lg'
}) => {
  const loadingAnimation = /*#__PURE__*/_jsx(AILoader, {
    isFinished: isFinished,
    onAnimationEnd: onAnimationEnd,
    size: size
  });
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "400",
    flexDirection: "column",
    alignItems: "center",
    paddingBlockEnd: "400",
    margin: "400",
    children: [loadingAnimation, /*#__PURE__*/_jsx(LoadingMessages, {
      messages: messages,
      isFinished: isFinished
    })]
  });
};
AIFullPageLoader.displayName = 'AIFullPageLoader';